module.exports = __webpack_public_path__ + "static/media/adminstration.0ac550be.svg";